module.exports = __webpack_public_path__ + "img/flag_it.1e0292fe.svg";